import React from 'react';

/* Decorative falling petals / confetti backdrop.
   Shared by the Leadership listing page (LeadershipTeam) and each
   per-member detail page (TeamMember) so the animation stays identical.

   Each entry: l=left %, s=size px, d=animation-delay s, t=duration s,
   k=variant (a/g amber+green petals, m/w confetti chips).
   Drop this inside a section that is position:relative + overflow:hidden
   (see .lead-section in aboutV2.css). */
const PETALS = [
    { l: 3, s: 16, d: -2, t: 14, k: 'a' },
    { l: 9, s: 10, d: -9, t: 12, k: 'm' },
    { l: 15, s: 13, d: -5, t: 16, k: 'g' },
    { l: 21, s: 9, d: -1, t: 11, k: 'w' },
    { l: 28, s: 17, d: -12, t: 17, k: 'a' },
    { l: 34, s: 11, d: -4, t: 13, k: 'g' },
    { l: 41, s: 14, d: -7, t: 15, k: 'm' },
    { l: 47, s: 10, d: -11, t: 12, k: 'a' },
    { l: 53, s: 15, d: -3, t: 18, k: 'w' },
    { l: 59, s: 12, d: -8, t: 14, k: 'g' },
    { l: 65, s: 9, d: -6, t: 11, k: 'm' },
    { l: 71, s: 16, d: -13, t: 16, k: 'a' },
    { l: 77, s: 11, d: -2, t: 13, k: 'w' },
    { l: 83, s: 14, d: -10, t: 17, k: 'g' },
    { l: 89, s: 10, d: -5, t: 12, k: 'm' },
    { l: 95, s: 13, d: -7, t: 15, k: 'a' },
];

const Petals = () => (
    <div className="lead-confetti" aria-hidden="true">
        {PETALS.map((p, i) => (
            <span
                key={i}
                className={"petal petal--" + p.k}
                style={{
                    left: p.l + "%",
                    width: p.s + "px",
                    height: p.s + "px",
                    animationDelay: p.d + "s",
                    animationDuration: p.t + "s",
                }}
            />
        ))}
    </div>
);

export default Petals;
